export const venueTypes = [
  'barn',
  'castle',
  'cityHotelCityVenue',
  'conferenceCentre',
  'countryHouseManorHouse',
  'cruiseBoatYacht',
  'gardenOutdoor',
  'golfCourse',
  'hotel',
  'museumAttraction',
  'other',
  'placeOfWorship',
  'pubRestaurant',
  'resort',
  'sportingVenueStadium',
  'statelyHome',
  'townHallRegistryOffice',
  'uniqueVenueType',
  'warehouseFactory',
];

export const venueStyles = [
  'outdoor',
  'classic',
  'intimate',
  'alternative',
  'romantic',
  'lovelyGrounds',
  'unusual',
  'affordable',
  'luxury',
  'rustic',
  'beach',
  'modern',
  'unique',
  'urban',
  'blankCanvas',
  'greatViews',
  'historic',
  'asian',
  'casual',
  'formal',
  'stylish',
];

export const venueFeatures = [
  'churchWithinWalkingDistance',
  'outdoorSpace',
  'disabledAccess',
  'marqueePermitted',
  'onsiteParking',
  'transportation',
  'wifi',
];

export const venuePricing = ['pricingIndicator', 'venueHirePriceMin', 'venueHirePriceMax'];
